import { render, staticRenderFns } from "./FamiliaConfiguracao.vue?vue&type=template&id=2059527a"
import script from "./FamiliaConfiguracao.vue?vue&type=script&lang=js"
export * from "./FamiliaConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports